import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const authService = {
  login: async (username, password) => {
    // Auth kontrolünü devre dışı bırak - her zaman başarılı
    localStorage.setItem('token', 'fake-token-for-development');
    return true;
    
    // Eski kod (devre dışı):
    /*
    try {
      const response = await api.post('/auth/login', { username, password });
      localStorage.setItem('token', response.data.token);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
    */
  }, 
  logout: () => {
    localStorage.removeItem('token');
    window.dispatchEvent(new StorageEvent('storage', {
      key: 'token',
      newValue: null,
      oldValue: localStorage.getItem('token')
    }));
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};

export default authService;